import {classes} from './Layout.st.css';
import {MainLoader} from './MainLoader/MainLoader';
import {AsideLoader} from './AsideLoader/AsideLoader';
import React, {ReactNode, useEffect, useState} from 'react';
import {pageTheme} from '../WithThemeOverride/pageTheme';
import {HeaderLoader} from './HeaderLoader/HeaderLoader';

export interface LayoutProps {
  isLoading: boolean;
  failedToFetch?: boolean;
  isOneColumnView?: boolean;
  shouldNotShowLoaderForMobileTopSummary?: boolean;
  Header: () => ReactNode;
  Aside: () => ReactNode;
  Footer: () => ReactNode;
  children: ReactNode;
  dataHook: string;
  dir: string;
}

export enum LayoutDataHooks {
  error = 'LayoutDataHooks.error',
  oneColumnViewSummary = 'LayoutDataHooks.oneColumnViewSummary',
  twoColumnViewSummary = 'LayoutDataHooks.twoColumnViewSummary',
}

export const Layout = ({
  dataHook,
  dir,
  isLoading,
  failedToFetch,
  isOneColumnView,
  Header,
  Aside,
  Footer,
  children,
  shouldNotShowLoaderForMobileTopSummary,
}: LayoutProps) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(!isLoading);
  }, [isLoading]);
  /* istanbul ignore next */
  const TopMobileLoader = () => (shouldNotShowLoaderForMobileTopSummary ? null : <AsideLoader />);

  return (
    <div data-hook={dataHook} className={classes.root} dir={dir} style={pageTheme}>
      {loaded ? Header() : <HeaderLoader />}
      <div className={classes.container}>
        {isOneColumnView && (
          <aside data-hook={LayoutDataHooks.oneColumnViewSummary} className={classes.aside}>
            {loaded ? Aside() : /* istanbul ignore next */ <TopMobileLoader />}
          </aside>
        )}
        <section className={classes.main}>{loaded ? children : <MainLoader />}</section>
        {!isOneColumnView && (
          <aside data-hook={LayoutDataHooks.twoColumnViewSummary} className={classes.aside}>
            {loaded ? Aside() : <AsideLoader />}
          </aside>
        )}
      </div>
      {loaded && Footer()}
      {/* TODO: get UX and error message */}
      {failedToFetch && (
        <div className={classes.error} data-hook={LayoutDataHooks.error}>
          Failed to Load!
        </div>
      )}
    </div>
  );
};
